@if (cloudProviders.length > 0) {
<div class="mb-5 mt-5">
  <div>
    <h4 class="h4">Your Permissions</h4>
    @if (loading) {
<img id="vf-loader" class="d-block m-auto" src="/assets/images/spinner_logo.svg" alt="spinner" />
}
    @if (!loading) {
<div class="p-3 mt-2 shadow bg-white">
      <table>
        <tbody>
          @for (csp of cloudProvidersNames; track csp) {
<tr>
            @if (cloudProvidersNames.length > 1) {
<td>
              <strong class="text-primary pe-3">
                {{ csp | uppercase }}
              </strong>
            </td>
}
            <td class="pe-2">
              @if (permissions[csp]?.global || (permissions[csp]?.resources?.length ?? 0) > 0) {
✓
}
              @if (!permissions[csp]?.global && (permissions[csp]?.resources?.length ?? 0) === 0) {
✗
}
            </td>
            <td [innerHTML]="permissions[csp].summary"></td>
          </tr>
}
        </tbody>
      </table>
    </div>
}
  </div>

  @if (canRequestPerms) {
<p class="mt-4">
    <strong>HINT</strong>: you can request permissions by clicking on <code>Access Request Form</code> on the
    <a fragment="vcloudsmart" routerLink="/dashboard">VCloudSmart dashboard</a>.
  </p>
}
</div>
}
